import { ClaimAction, ClaimActionTypes, ClaimState } from "./types";

const initialState: ClaimState = {
  claimId: "",
  plan: {},
  customerId: "",
  warranty_items: [],
  claim_items: [],
  status: "",
  damages: [],
};

export const claimReducer = (
  state: ClaimState = initialState,
  action: ClaimActionTypes
): ClaimState => {
  switch (action.type) {
    case ClaimAction.SET_CLAIM_INFO: {
      return {
        ...state,
        claimId: action?.payload?.claimId || state?.claimId || "",
        status: action?.payload?.status || state?.status || "",
        plan: action?.payload?.plan || state?.plan || {},
        warranty_items:
          action?.payload?.warranty_items || state?.warranty_items || [],
        claim_items: action?.payload?.claim_items || state?.claim_items || [],
        customerId: action?.payload?.customerId || state?.customerId || {},
        damages: action?.payload?.damages || state?.damages || [],
      };
    }

    case ClaimAction.CLEAN_UP: {
      return {
        ...state,
        claimId: "",
        plan: {},
        warranty_items: [],
        claim_items: [],
        customerId: "",
      };
    }

    default:
      return state;
  }
};
